// src/auth/protected-route.js

import React, { useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '../components/index';
import { useSelector } from 'react-redux';
import { ROUTE_CLAIMS_LIST } from 'constants/userClaims';
import { hasClaims } from 'hooks/useHasClaims';
import { isEmpty, isUndefined } from 'lodash';
import AccessDenied from 'components/AccessDenied';
import { EXECUTIVE_SUMMARY, TPIR_SUBSCRIBED } from 'constants/constants';
import { datadogLogs } from '@datadog/browser-logs'

const ProtectedRoute = ({ component, path, ...args }) => {
  const userClaimList = useSelector((state) => state?.session?.details?.FeatureActionClaimList);
  const latestContractConfiguration = useSelector((state) => state.client.latestContractConfiguration);
  const [accessDenied, setAccessDenied] = useState(false);
  const details = useSelector((state) => state.session.details);

  useEffect(() => {
    const currentRoute = ROUTE_CLAIMS_LIST.find((item) => path === item.route);
    if (!isEmpty(currentRoute) && currentRoute?.claims?.length > 0 && !isUndefined(userClaimList)) {
      if (!hasClaims(currentRoute?.claims, userClaimList, currentRoute?.shouldHaveAllClaims)) {
        setAccessDenied(true);
        datadogLogs.logger.error("Access Denied", {
          event: "Access Denied",
          message: "User attempted to access a restricted page",
          url: window.location.href,
          userId: details.UserId,
          userClaimList: userClaimList,
          currentRoute: currentRoute,
          latestContractConfiguration: latestContractConfiguration
        });
      }
    }
  }, [userClaimList, path]);

  useEffect(() => {
    const currentRoute = ROUTE_CLAIMS_LIST.find((item) => path === item.route);
    if (!isEmpty(currentRoute) && !isUndefined(latestContractConfiguration) && !isEmpty(latestContractConfiguration)) {
      if ((currentRoute?.isTPIRSubscribedCheck && latestContractConfiguration?.IsTPIRSubscribed === TPIR_SUBSCRIBED.NO)
        || (currentRoute?.isExecutiveSummaryCheck && latestContractConfiguration?.ExecutiveSummary === EXECUTIVE_SUMMARY.NO)) {
        setAccessDenied(true);
        datadogLogs.logger.error("Access Denied", {
          event: "Access Denied",
          message: "User attempted to access a restricted page",
          url: window.location.href,
          userId: details.UserId,
          userClaimList: userClaimList,
          currentRoute: currentRoute,
          latestContractConfiguration: latestContractConfiguration
        });
      }
    }
  }, [latestContractConfiguration, path]);

  if (accessDenied) {
    return <Route component={AccessDenied} path={path} {...args} />;
  }

  return (
    <Route
      component={withAuthenticationRequired(component, {
        onRedirecting: () => <Loading />,
      })}
      path={path}
      {...args}
    />
  );
};

export default ProtectedRoute;
